/**
 * What the album is made of, as the 3D preview draws it : how thick a sheet and a cover are, how
 * far a hard cover overhangs the pages, and for a spiral binding the gap between the two sides,
 * the punched holes and the rings. Figures in millimetres, from the cover option :
 *
 *   - soft (and stapled) : a thin cover, the size of the pages
 *   - hard and layflat : a board a few millimetres thick, overhanging the pages ; layflat sheets
 *     are thick ones (two prints glued back to back)
 *   - spiral : a stiff cover, the sheets apart from each other on a wire coil through holes
 *
 *   new desktop.common.preview.BookBinding(book)
 *   holes(edge)      the holes of a page as fractions of its size, for PageArtwork : null but spiral
 */
fx.ns("desktop.common.preview", class BookBinding {

    constructor(book)
    {
        this.type = book.isSpiral ? "spiral" : ((book.isHard || book.isLayFlat) ? "hard" : "soft");
        this.layflat = !!book.isLayFlat;

        this.pageWidth = book.pageWidth;
        this.pageHeight = book.pageHeight;

        // a little thicker than the real ones (0.3 mm a sheet, 2.5 mm a board) : at the preview's
        // scale the real figures read as a soft cover
        this.sheet = this.layflat ? 1.4 : 0.6;
        this.cover = { hard : 4, spiral : 1.5, soft : 0.4 }[this.type];
        this.overhang = (this.type == "hard") ? 3.5 : 0;

        // spiral : the gap between the two sides at the coil, and the holes (centre from the edge,
        // diameter), every 3:1 pitch (8.47 mm)
        this.gap = this.spiral ? 2.5 : 0;
        this.holeOffset = 3.5;
        this.holeDiameter = 3;
        this.pitch = 8.47;

        // past this many pages the album gets no thicker : its sheets get thinner instead, or a
        // long album would stand on the table like a brick
        this.maxPages = 80;
    }

    /**
     * How much of its thickness a sheet keeps : 1 up to maxPages, less beyond.
     * @param {Number} pages : the album's pages, two a sheet
     */
    sheetShare(pages)
    {
        return (pages > this.maxPages) ? this.maxPages / pages : 1;
    }

    get spiral()
    {
        return this.type == "spiral";
    }

    get hard()
    {
        return this.type == "hard";
    }

    // the centres of the holes down the binding edge, millimetres from the top of the page
    get holeCentres()
    {
        let margin = 6,
            count = Math.max(2, Math.floor((this.pageHeight - 2 * margin) / this.pitch) + 1),
            first = (this.pageHeight - (count - 1) * this.pitch) / 2,
            centres = [];

        for (let i = 0; i < count; i++)
            centres.push(first + i * this.pitch);

        return centres;
    }

    /**
     * The holes punched in a page, as fractions of the page, for PageArtwork.
     * @param {String} edge : the binding edge of the picture, "left" | "right"
     */
    holes(edge)
    {
        if (!this.spiral || !edge)
            return null;

        return {
            edge : edge,
            x : this.holeOffset / this.pageWidth,
            r : this.holeDiameter / 2 / this.pageWidth,
            ys : this.holeCentres.map((y) => y / this.pageHeight),
        };
    }
});
